import { create } from 'zustand';

type State = {
  visible: boolean,
}

type Actions = {
  toggleVisibility: () => void,
}

export const useToggleValuesVisibilityStore = create<State & Actions>(
  (set) => ({
    visible: true,
    toggleVisibility: () => set((state) => ({ visible: !state.visible })),
  }),
);